import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UniversityScreen from "./screens/UniversityScreen";
import ContactScreen from "./screens/ContactScreen";
import UniversityCreateScreen from "./screens/UniversityCreateScreen";
import UniversityEditScreen from "./screens/UniversityEditScreen";
import InvoiceCreateScreen from "./screens/InvoiceCreateScreen";
import DashboardScreen from "./screens/DashboardScreen";
import ErrorScreen from "./screens/ErrorScreen";
import InvoiceScreen from "./screens/InvoiceScreen";
import LoginScreen from "./screens/LoginScreen";
import SubAgentScreen from "./screens/SubAgentScreens";
import SubAgentCreateScreen from "./screens/SubAgentCreateScreen";
import SubAgentEditScreen from "./screens/SubAgentEditScreen";
import AffiliatePartnerScreen from "./screens/AffiliatePartnerScreens";
import AffiliatePartnerCreateScreen from "./screens/AffiliatePartnerCreateScreen";
import AffiliatePartnerEditScreen from "./screens/AffiliatePartnerEditScreen";
import PartnerAgentScreen from "./screens/PartnerAgentScreens";
import PartnerAgentCreateScreen from "./screens/PartnerAgentCreateScreen";
import PartnerAgentEditScreen from "./screens/PartnerAgentEditScreen";
import LogoutScreen from "./screens/LogoutScreen";
import InvoiceEditScreen from "./screens/InvoiceEditScreen";
import VasCreateScreen from "./screens/VasCreateScreen";
import VasScreen from "./screens/VasScreen";
import Document from "./screens/DocumentScreen";
import InvoiceSubAgentScreen from "./screens/InvoiceSubAgentScreen";
import InvoiceSubAgentInternalScreen from "./screens/InvoiceSubAgentInternalScreen";
import TaskScreen from "./screens/TaskScreen";
import SubAgentEditScreen2 from "./screens/SubAgentEditScreen2";

export default function App() {
  const [noHeaderPage, setNoHeaderPage] = useState(false);
  const [pageName, setPageName] = useState("");

  const checkPage = () => {
    const pages = ["/login", "/forgot-password"];
    setPageName(window.location.pathname.toLowerCase());
    if (pages.includes(pageName)) {
      setNoHeaderPage(true);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/login" element={<LoginScreen />} />
          <Route exact path="/contact/:id" element={<ContactScreen />} />
          <Route exact path="/" element={<DashboardScreen />} />

          {/* College Pages */}
          <Route exact path="/university" element={<UniversityScreen />} />
          <Route
            path="/university/create"
            element={<UniversityCreateScreen />}
          />
          <Route
            path="/university/edit/:id"
            element={<UniversityEditScreen />}
          />

          {/* Sub Agent Pages */}
          <Route exact path="/sub-agent" element={<SubAgentScreen />} />
          <Route
            exact
            path="/sub-agent/create"
            element={<SubAgentCreateScreen />}
          />
          <Route
            exact
            path="/sub-agent/edit/:id"
            // element={<SubAgentEditScreen />}
            element={<SubAgentEditScreen2/>}
          />

          {/* Affiliate Partner Pages */}
          <Route
            exact
            path="/affiliate-partner"
            element={<AffiliatePartnerScreen />}
          />
          <Route
            exact
            path="/affiliate-partner/create"
            element={<AffiliatePartnerCreateScreen />}
          />
          <Route
            exact
            path="/affiliate-partner/edit/:id"
            element={<AffiliatePartnerEditScreen />}
          />

          {/* Partner Agent Pages */}
          <Route exact path="/partner-agent" element={<PartnerAgentScreen />} />
          <Route
            exact
            path="/partner-agent/create"
            element={<PartnerAgentCreateScreen />}
          />
          <Route
            exact
            path="/partner-agent/edit/:id"
            element={<PartnerAgentEditScreen />}
          />

          {/* Invoice Pages */}
          <Route path="/invoice" element={<InvoiceScreen />} />
          <Route path="/invoice/create" element={<InvoiceCreateScreen />} />
          <Route path="/invoice/edit/:Id" element={<InvoiceEditScreen />} />
          <Route path="/logout" element={<LogoutScreen />} />

          {/* Value Added Services Record */}
          <Route path="/invoice/vas" element={<VasScreen />} />
          <Route path="/invoice/vas/create" element={<VasCreateScreen />} />

          {/* Invoice Sub Agent Pages */}
          <Route path="/invoice/subagent" element={<InvoiceSubAgentScreen />} />
          <Route path="/invoice/subagentinternal" element={<InvoiceSubAgentInternalScreen />} />

          {/* Task Pages */}
          <Route path="/task" element={<TaskScreen />} />

          {/* Document Page */}
          <Route path="/document" element={<Document />} />

          {/* Error Page */}
          <Route path="/*" element={<ErrorScreen />} />
        </Routes>
      </Router>
    </>
  );
}
